import { render } from "./Team.vue?vue&type=template&id=c06de812"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
script.render = render

export default script